module.exports = __webpack_public_path__ + "img/ICP.4f846e08.jpg";